// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__16Oua","inputWrap":"Table_inputWrap__2jEY8","col":"Table_col__2jJ5-","bmiTooltip":"Table_bmiTooltip__26Fk9"};